import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,2.14285714 L20,17.8571429 C20,19.040625 19.040625,20 17.8571429,20 L2.14285714,20 C0.959375,20 0,19.040625 0,17.8571429 L0,2.14285714 C0,0.959375 0.959375,0 2.14285714,0 L17.8571429,0 C19.040625,0 20,0.959375 20,2.14285714 Z M16.0714286,2.85714286 L11.0727232,2.85714286 C10.12125,2.85714286 9.64058036,4.01165179 10.3150893,4.68620536 L11.7429464,6.11419643 L3.0140625,14.8430804 C2.80486607,15.0522768 2.80486607,15.3914732 3.0140625,15.6007143 L4.39928571,16.9859375 C4.60852679,17.1951339 4.94772321,17.1951339 5.15691964,16.9859375 L13.8857589,8.25709821 L15.3137946,9.68526786 C15.9847321,10.3561161 17.1428571,9.88504464 17.1428571,8.92763393 L17.1428571,3.92857143 C17.1428571,3.33683036 16.6631696,2.85714286 16.0714286,2.85714286 Z",
  id: "Shape"
});

var SvgExternal = function SvgExternal(props) {
  return _ref;
};

export default SvgExternal;